'use strict';

import PropTypes from 'prop-types';

import React from 'react';
import PlayLinkContainer from './PlayLinkContainer.jsx';
import ExternalIcon from './ExternalIcon.jsx';
import classNames from 'classnames';

class PlayLinkExternal extends React.Component {
    render() {
        let { url, text, className, ...other } = this.props;
        let linkClasses = classNames('play_link-external', className);

        if (!text) {
            text = this.props.children;
        }

        return (
            <PlayLinkContainer to={url} isExternal={true} className={linkClasses} {...other}>
                <ExternalIcon isExternal={true}>
                    <span className="play_link-external__target">{text}</span>
                </ExternalIcon>
            </PlayLinkContainer>
        );
    }
}

PlayLinkExternal.propTypes = {
    url: PropTypes.string.isRequired,
    text: PropTypes.string,
    className: PropTypes.string,
};

export default PlayLinkExternal;
